import { useaxios } from "../../../utils/useaxios";
export default (months_difference) => clear => setitems => settotal_6_to_9_months => settotal_more_than_9_months => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    useaxios('remained_item/remained_item.php', { months_difference }).then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        } else if (res == "request_failed") {
            alert('no internet connection');
            return false;
        } else if (res.status == "ok") {
            console.log(res);

            setitems(res?.data);
            settotal_6_to_9_months(res?.total_6_to_9_months);
            settotal_more_than_9_months(res?.total_more_than_9_months);
        }
    });
}